import axiosApiInstance from '../../../api/axiosClient';

export async function fetchArtistSearchResults(
    query: string,
    limit = 20,
): Promise<API.MusicDistribution.ArtistSearchResult[]> {
    const q = query.trim();
    if (q.length < 2) {
        return [];
    }
    const response = await axiosApiInstance.get<API.MusicDistribution.ArtistSearchResult[]>(
        '/api/products/artists/search',
        { params: { q, limit } },
    );
    return response.data ?? [];
}
